import { Injectable } from '@angular/core';
import { XhrService } from '../../core/services/xhr-service/xhr.service';
import {
  FilterRequestDto,
  FindAllPhoneResponseDTO,
  FindBaseDeviceDetailDataRequestDto,
  FindBaseDeviceDetailDataResponeDto,
  FindCardDataForDeviceDetailRequestDto,
  FindCardDataForDeviceDetailResponseDto,
  FindInstallmentsForDeviceDetailRequestDto,
  FindInstallmentsForDeviceDetailResponseDto,
  GetPhoneDetailsByIdRequestDTO,
  GetPhoneDetailsByIdResponseDTO,
  SearchFilterResponseDTO,
} from './phone.interfaces';
import { API } from '../../global/API.constants';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetPhoneOrderDetailsRequestDto, IGetPhoneOrderDetailsResponseDto } from '../order/order.interfaces';
import { Params } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PhoneService {
  constructor(private xhr: XhrService) {}

  findAll(request?: Partial<FilterRequestDto>): Observable<FindAllPhoneResponseDTO> {
    if (request) {
      let queryParams = new HttpParams();
      Object.entries(request)
        .filter(([key, value]) => {
          if (Array.isArray(value)) {
            return value.length > 0;
          }
          return true;
        })
        .forEach(([key, value]) => (queryParams = queryParams.append(key, value + '')));
      return this.xhr.get<FindAllPhoneResponseDTO>(API.device.findAll, { params: queryParams });
    }
    return this.xhr.get<FindAllPhoneResponseDTO>(API.device.findAll);
  }

  getPhoneDetailsById(request: GetPhoneDetailsByIdRequestDTO): Observable<GetPhoneDetailsByIdResponseDTO> {
    return this.xhr.post<GetPhoneDetailsByIdResponseDTO>(API.device.findByDeviceCode, request);
  }

  // getPhoneDetailsByName(request: GetPhoneDetailsByNameRequestDTO): Observable<GetPhoneDetailsByNameResponseDTO> {
  //   return this.xhr.post<GetPhoneDetailsByNameResponseDTO>(API.device.findByDeviceName, request);
  // }

  getSearchFilter(): Observable<SearchFilterResponseDTO> {
    return this.xhr.get<SearchFilterResponseDTO>(API.device.findAllFilter);
  }

  findBaseDeviceDetailData(
    request: FindBaseDeviceDetailDataRequestDto
  ): Observable<FindBaseDeviceDetailDataResponeDto> {
    return this.xhr.post<FindBaseDeviceDetailDataResponeDto>(API.device.findBaseDeviceDetailData, request);
  }

  findCardDataForDeviceDetail(
    request: FindCardDataForDeviceDetailRequestDto
  ): Observable<FindCardDataForDeviceDetailResponseDto> {
    return this.xhr.post<FindCardDataForDeviceDetailResponseDto>(API.device.findCardDataForDeviceDetail, request);
  }

  findInstallmentsForDeviceDetail(
    request: FindInstallmentsForDeviceDetailRequestDto
  ): Observable<FindInstallmentsForDeviceDetailResponseDto> {
    return this.xhr.post<FindInstallmentsForDeviceDetailResponseDto>(
      API.device.findInstallmentsForDeviceDetail,
      request
    );
  }

  getDeviceOrderDataByIds(request: IGetPhoneOrderDetailsRequestDto): Observable<IGetPhoneOrderDetailsResponseDto> {
    return this.xhr.get<IGetPhoneOrderDetailsResponseDto>(API.device.findForOrder, { params: request });
  }
}
